module.exports = __webpack_public_path__ + "static/media/tab-slurp-creamy.80864ed0.png";